export default __webpack_public_path__ + "static/media/RunHorseLight_4_1.b70e5105.jpg";